import { REQUESTING_PLATFORM_TO_CODES } from './requesting-platform';

export const REQUESTING_PLATFORM_CURRENCIES = {
  [REQUESTING_PLATFORM_TO_CODES.ITAU]: ['CLP', 'USD'],
};

export const getCurrenciesForPlatform = (requestingPlatform, countryCurrencies = []) => (
  REQUESTING_PLATFORM_CURRENCIES[requestingPlatform] || countryCurrencies
);
